import angular from 'angular';

import './password-change.styles.scss';

import PasswordChangeController from './password-change.controller';

export default angular.module('autoboard.passwordChange', [])
  .directive('passwordChange', () => {
    'ngInject';

    return {
      controller: PasswordChangeController,
      restrict: 'E',
      templateUrl: require('./password-change.template.html'),
    };
  })
  .name;
